import { ComponentProps } from 'react';
import Heading from '@alltrails/denali/components/Heading';
import { useModalAriaLabelledBy } from './ModalAriaLabelledByContext';

type Props = Omit<ComponentProps<typeof Heading>, 'id'>;

export default function ModalAriaLabelledByHeading({ as, children, className, size }: Props) {
  const id = useModalAriaLabelledBy();
  return (
    <Heading as={as} className={className} id={id} size={size}>
      {children}
    </Heading>
  );
}
